import React from 'react'
import { Radio, FormDashboardInput as Input } from './dashboard-form'
import { Button } from './buttons'

const MediaUploader = ({type}) => {
  const [form, setForm] = React.useState({
    upload_type: 'upload'
  })

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const [files, setFiles] = React.useState([])
  const fileInput = React.useRef()

  const handleChange = (e) => {
    const cloned = JSON.parse(JSON.stringify(files))
    const filename = e.target.files[0].name
    cloned.push(filename)
    setFiles(cloned)
  }

  return (
    <div>
      <div>
        <div className="flex flex-wrap lg:items-center mb-4">
          <div className="w-1/2 lg:w-auto">
            <Radio
              name="upload_type"
              id="upload_type"
              value="upload"
              label={`Upload ${type}`}
              className="mr-5 mb-2 lg:mb-0"
              form={form}
              onChange={updateForm}
            />
          </div>
          <div className="w-1/2 lg:w-auto">
            <Radio
              name="upload_type"
              id="upload_type1"
              value="embed"
              label={`Embed ${type}`}
              className="mr-5 mb-2 lg:mb-0"
              form={form}
              onChange={updateForm}
            />
          </div>
        </div>
      </div>
      <div>
        {
          form.upload_type === 'upload' &&
          <div>
            <div className="flex items-center mb-8">
              <p className="font-bold text-primary underline mr-4 text-sm">Learn-program-frosh.mp4</p>
              <p className="text-xs text-gray-999 underline">Delete</p>
            </div>
            {
              files.map((f, i) => (
                <div className="flex items-center mb-8" key={i}>
                  <p className="font-bold text-primary underline mr-4 text-sm">{f}</p>
                  <p className="text-xs text-gray-999 underline">Delete</p>
                </div>
              ))
            }

            <input type="file" className="hide hidden" onChange={handleChange} ref={fileInput}/>

            <div
              className="border border-dashed rounded p-6 flex items-center justify-center cursor-pointer"
              style={{borderColor: '#ddd'}}
              onClick={() => fileInput.current.click()}
            >
              <p className="text-gray-999 underline text-sm">Update file</p>
            </div>
          </div>
        }
        {
          form.upload_type === 'embed' &&
          <div className="flex items-center">
            <Input placeholder="Enter URL" className="mr-4 w-full"/>
            <div style={{maxWidth: '220px'}}>
              <Button thin>Add</Button>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export { MediaUploader }
